export class InputMessageDataParm{
  public msgTitle: string;
  public msgDisplayed: string;
  public msgInput: string;
}
